<style></style>

<template>
  <div>
    <program-progress
      :program="program"
      :assessments="assessments"
      :modules="modules"
      class="mb-4"
      :survey-cutoffs="surveyCutoffs"
    ></program-progress>

    <!-- <h2 class="lighter" id="landing">My Activities</h2>
        <how-to-row>
            <template #left>
                <how-to-video></how-to-video>
            </template>
            <template #right>
                <a :href="$basePath+'/uploads/GNS_UserGuide_Full.pdf'" target="_blank"><span class="icon-book"></span></a>
                <a :href="$basePath+'/uploads/GNS_UserGuide_Full.pdf'" target="_blank" class="link-lighter">View the How-To Guide</a>
            </template>
        </how-to-row> -->

    <h2 class="lighter" id="landing">
      Welcome to your dashboard. Please follow these 4 steps to complete an
      ACCESS cycle:
    </h2>
    <p class="text--primary dashboard-steps">
      <div class="dashboard-step">
        <span>
            (1)
        </span>
        <div>
            Assess – Use the <a :href="`${$basePath}/self-assessments`">Self-Assessment</a> page to answer questions about your program’s practices and compare them to ACCESS evidence-based practices across multiple program areas.  
        </div>
      </div>
      <div class="dashboard-step">
        <span>
            (2)
        </span>
        <div>
            Plan – Set goals and create plans for change using the <a :href="`${$basePath}/action-plans`">Action Planning</a> page. 
        </div>
      </div>
      <div class="dashboard-step">
        <span>
            (3)
        </span>
        <div>
            Learn More – Access resources in the <a :href="`${$basePath}/tips-and-materials`">Tips & Materials</a> page to help support your action steps.
        </div>
      </div>
      <div class="dashboard-step">
        <span>
            (4)
        </span>
        <div>
           Keep It Up – Use the <a :href="`${$basePath}/self-assessments`">Self-Assessment</a> page to reassess, track your progress, and select new goals.  
        </div>
      </div>
      
    </p>
    <div class="assessments-steps-component">
      <img
        :src="`${$basePath}/images/adult-care/ACCESS_Dashboard Graphic_4Steps.png`"
        alt=""
      />
    </div>
    <div class="assessments-dash-component d-none">
      <dashboard-tabs
        :program="program"
        :modules="modules"
        :assessments="assessments"
      >
        <template #primary="{ module }">
          <assessment-actions
            :module="module"
            :assessments="assessmentsInModule(module)"
          ></assessment-actions>
        </template>

        <template #secondary="{ module }">
          <div :class="'border-' + module.color" class="mx-0 p-4 border-top-0">
            <span class="five-steps-number two float-left"></span>
            <h3 class="lighter text-dark-orange pt-1 mb-0">Plan</h3>
            <action-plan-list
              :module="module"
              :action-plans="plansInModule(module.id)"
              :assessments="assessmentsInModule(module)"
            ></action-plan-list>
          </div>

          <div
            :class="'border-' + module.color"
            class="completed-assessments mx-0 p-4 border-top-0 row"
          >
            <div class="col-sm-4 step-number">
              <div class="five-steps-number three float-left"></div>
              <h3
                class="lighter text-dark-orange pt-1 ml-2"
                style="white-space: nowrap"
              >
                Take Action
              </h3>
              <a
                :href="$basePath + '/tips-and-materials/'"
                class="btn btn-orange-blue text-white btn-sm w-100"
              >
                View Tips &amp; Materials
              </a>
            </div>
            <div class="col-sm-4 step-number">
              <div class="five-steps-number four float-left"></div>
              <h3 class="lighter text-dark-orange pt-1">Learn More</h3>
              <a
                :href="$basePath + '/provider-trainings'"
                class="btn btn-orange-blue text-white btn-sm w-100"
              >
                View Available Trainings
              </a>
            </div>
            <div class="col-sm-4 step-number">
              <div class="five-steps-number five float-left"></div>
              <h3 class="lighter text-dark-orange pt-1">Keep It Up</h3>
              <a
                :href="$basePath + '/self-assessments/' + module.slug + '/new'"
                class="btn btn-orange-blue text-white btn-sm w-100"
              >
                Retake My Assessment
              </a>
            </div>
          </div>
        </template>
      </dashboard-tabs>
    </div>
  </div>
</template>

<script>
import DashboardTabs from "../dashboard_tabs/DashboardTabs";
import ProgramProgress from "./ProgramProgress";
import HowToVideo from "../HowToVideo";
import AssessmentActions from "../assessments/AssessmentActions";
import ActionPlanList from "../action_plans/ActionPlanList";
import HowToRow from "../HowToRow";

export default {
  components: {
    DashboardTabs,
    ProgramProgress,
    HowToVideo,
    AssessmentActions,
    ActionPlanList,
    HowToRow,
  },
  props: {
    program: {
      required: true,
      type: Object,
    },
    modules: {
      required: true,
      type: Array,
    },
    assessments: {
      required: true,
      type: Array,
    },
    actionPlans: {
      required: true,
      type: Array,
    },
    surveyCutoffs: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    plansInModule(moduleId) {
      return this.actionPlans
        ? this.actionPlans.filter(
            (ap) => ap.goal.best_practice.module_id == moduleId
          )
        : [];
    },
    assessmentsInModule(module) {
      return this.assessments.filter(
        (assessment) => assessment.survey.module_id == module.id
      );
    },
  },
  computed: {
    $basePath() {
      return window.basePath;
    },
  },
};
</script>
